export default "__VITE_ASSET__75fd4bf6__"